import * as Yup from 'yup';
import dayjs from 'dayjs';

export const routeHistoryFiltersSchema = Yup.object().shape({
  start: Yup.date()
    .nullable()
    .min(dayjs(new Date(2018, 0, 1)), {
      key: 'min_date',
      value: '2018-01-01',
    })
    .when('end', {
      is: (end) => end,
      then: Yup.date().required(),
    }),

  end: Yup.date()
    .nullable()
    .min(dayjs(new Date(2018, 0, 1)), {
      key: 'min_date',
      value: '2018-01-01',
    }),
});

export const defaultRouteHistoryFilters = {
  page: 1,
  start: null,
  end: null,
};
